import { installedModules } from './registry.js';
import { useModules } from './use-modules.js';

export function useDocumentVerificationMode(token) {
  const entitlements = useModules(token);
  return installedModules.some((module) => module.replacesDocumentUploads === true
    && entitlements.some((entry) => entry.key === module.key && entry.enabled)) ? 'external' : 'upload';
}
